<template>
  <g-master name="rolecompetitions"
            :endpoint="shiftMaster.endpoint"
            :tableSetup="shiftMaster.tableSetup"
            :modalFieldsSetup="shiftMaster.modalFieldsSetup"
            :parentData="parentData"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" label="Descripción">
            <a-input
              v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
          <a-form-item v-bind="fiOptions" label="Valor (peso)">
            <a-input-number
              v-decorator="['value', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 12},
          'has-feedback': true
        },
        shiftMaster: {
          endpoint: 'rol_competency',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_rol_competency'
            },
            columns: [
              {title: 'Descripcion', dataIndex: 'description', sorter: true},
              {title: 'Valor (peso)', dataIndex: 'value', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'value'}
          ]
        }
      }
    },
    props: ['id_evaluation'],
    computed: {
      parentData () {
        return {id_management_skill: this.id_evaluation}
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/CompetenciaDeRoles.vue